import type { ProjectStatus } from '@/utils/projectStatuses';
import { STAGE_LETTER } from '../model/stageLetter';
import { getStageKey, stageColorVar } from '../model/projectView';
import { TypeSwatch } from './TypeTag';

/** Заливка слева направо поверх обычных 16 %: пройденная доля цепочки подстатусов (--f) — цветом этапа 55 % */
const PROGRESS_FILL =
  'nd:[background:linear-gradient(to_right,color-mix(in_oklab,var(--t)_55%,transparent)_var(--f),transparent_var(--f))_color-mix(in_oklab,var(--t)_16%,transparent)]';

/**
 * Квадратик этапа: цвет этапа и его буква (полоса этапа карточки, меню этапа).
 * С progress — без буквы, залит слева направо на долю пройденных подстатусов (концепт stage-submenu-squares, 1.4).
 */
export function StageSwatch({ status, progress }: { status: ProjectStatus; progress?: number | null }) {
  const color = stageColorVar(getStageKey(status));
  if (progress == null) return <TypeSwatch color={color} letter={STAGE_LETTER[status]} className="nd:stage-fade" />;
  return (
    <TypeSwatch
      color={color}
      className={`nd:stage-fade ${PROGRESS_FILL}`}
      style={{ '--f': `${Math.round(progress * 1000) / 10}%` }}
      data-progress={progress}
    />
  );
}
